import { render } from "./Temp.vue?vue&type=template&id=ae14cdd6"
import script from "./Temp.vue?vue&type=script&lang=js"
export * from "./Temp.vue?vue&type=script&lang=js"

import exportComponent from "/Users/victoriengarrigues/Documents/Moonarch-DEV/code/moonarch-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__